function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M0 0h30v30H0z"
}), React.createElement("path", {
  fill: "#006AB3",
  d: "M15.02 29.449c-1.236 0-2.348-.815-2.843-1.908a2.731 2.731 0 0 1-2.11-2.656v-3.58c0-1.383-.594-2.73-1.63-3.69A9.645 9.645 0 0 1 5.38 9.63c.419-4.677 4.265-8.442 8.955-8.766.46-.032.909-.032 1.369 0 4.69.324 8.536 4.089 8.955 8.766a9.644 9.644 0 0 1-3.058 7.985 5.062 5.062 0 0 0-1.63 3.69v3.58a2.73 2.73 0 0 1-2.11 2.656c-.494 1.093-1.606 1.908-2.842 1.908zm2.316-3.16a1.41 1.41 0 0 0 1.315-1.404v-3.58c0-1.752.749-3.449 2.052-4.658a8.325 8.325 0 0 0 2.641-6.899c-.36-4.031-3.688-7.288-7.73-7.567a8.545 8.545 0 0 0-1.188 0c-4.043.279-7.37 3.536-7.731 7.567a8.325 8.325 0 0 0 2.64 6.899 6.382 6.382 0 0 1 2.052 4.659v3.579c0 .74.579 1.355 1.315 1.404l.46.03.13.442c.221.755.958 1.368 1.727 1.368.77 0 1.506-.613 1.728-1.368l.13-.442.46-.03z"
}), React.createElement("path", {
  fill: "#006AB3",
  d: "M11.252 22.964h7.534v1.17h-7.534v-1.17zm7.534-2.296v1.17h-7.534v-1.17h7.534zM11.33 25.26h7.978c-.188.687-.618 1.17-1.119 1.17h-5.74c-.5 0-.93-.482-1.119-1.17zm3.69 2.405c-.483 0-.906-.337-1.136-.71h2.271c-.231.373-.653.71-1.136.71z"
}));

var SvgIcLightbulb = function SvgIcLightbulb(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-lightbulb.950cdd10.svg";
export { SvgIcLightbulb as ReactComponent };